import AccountingService from "@/services/feature/accounting.service";

export const accounting = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    generateGoodByeLetter({ commit }, { loanNumber, dueDate, downloadOnly }) {
      return AccountingService.generateGoodByeLetter(loanNumber, dueDate, downloadOnly).then(
        (resp) => {
          commit("dummy", "generateGoodByeLetter - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "generateGoodByeLetter - error");
          return Promise.reject(error.response);
        }
      );
    },
    generateEndorsementLetter({ commit }, { loanNumber, endorseDate, downloadOnly }) {
      return AccountingService.generateEndorsementLetter(
        loanNumber,
        endorseDate,
        downloadOnly
      ).then(
        (resp) => {
          commit("dummy", "generateEndorsementLetter - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "generateEndorsementLetter - error");
          return Promise.reject(error.response);
        }
      );
    },
    generateMortgageStatement({ commit }, { loanNumber, dueDate, downloadOnly }) {
      return AccountingService.generateMortgageStatement(loanNumber, dueDate, downloadOnly).then(
        (resp) => {
          commit("dummy", "generateMortgageStatement - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "generateMortgageStatement - error");
          return Promise.reject(error.response);
        }
      );
    },
    generateForm1098({ commit }, { loanNumber, dueDate, downloadOnly }) {
      return AccountingService.generateForm1098(loanNumber, dueDate, downloadOnly).then(
        (resp) => {
          commit("dummy", "generateForm1098 - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "generateForm1098 - error");
          return Promise.reject(error.response);
        }
      );
    },
    generatePurchaseAdvice({ commit }, { loanNumber, downloadOnly, additionalAdjustment }) {
      return AccountingService.generatePurchaseAdvice(
        loanNumber,
        downloadOnly,
        additionalAdjustment
      ).then(
        (resp) => {
          commit("dummy", "generatePurchaseAdvice - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "generatePurchaseAdvice - error");
          return Promise.reject(error.response);
        }
      );
    },
    generateLoanPayment({ commit }, { loanNumber, dueDate, downloadOnly }) {
      return AccountingService.generateLoanPayment(loanNumber, dueDate, downloadOnly).then(
        (resp) => {
          commit("dummy", "generateLoanPayment - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "generateLoanPayment - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
